export const PARAMS = "api/leo_parametros.php";
export const LOGIN = "api/leo_usuario.php";
export const GET_FAMILY = "api/leo_familiar.php";
export const SEND_SMS = "api/enviar_sms.php";
export const SUBMIT_INSCRIPCION = "api/grabo_inscripcion.php";
export const BAJAR_PDF = "api/ficha_inscripcion.php";
export const DESLINDE_PDF = "api/deslinde.php";
export const FILE_MANAGER = "api/file_manager.php";
